var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"files-list-drag-image"},[_c('span',{staticClass:"files-list-drag-image__icon"},[_c('span',{ref:"previewImg"}),_vm._v(" "),(_vm.isSingleFolder)?_c('FolderIcon'):_c('FileMultipleIcon')],1),_vm._v(" "),_c('span',{staticClass:"files-list-drag-image__name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }